import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { ViewComponent } from './view/view.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';

const routes: Routes = [
  {
    path:'',
    children:[
      { path:'' , redirectTo:'list' , pathMatch:'full'},
      {
        path:'list',component:ListComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment','Sales','Engineering','HR','Training Moderator','Teacher','Operation','Finance'] } 
      },
      {
        path:'add',component:AddComponent
      },
      {
        path:'view/:id',component:ViewComponent
      },
      {
        path:'edit/:id',component:AddComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TaskRoutingModule { }
